import { useMaintenance } from '@/contexts/useMaintenance';
import { useAuth } from '@/contexts/useAuth';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { AlertTriangle, Settings, LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const MaintenancePage = () => {
  const { maintenanceStatus } = useMaintenance();
  const { signOut, userRole } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate('/');
  };

  const handleAdminPanel = () => {
    navigate('/admin/settings');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-red-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardContent className="p-8 text-center space-y-6">
          <div className="mx-auto w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center">
            <AlertTriangle className="h-8 w-8 text-orange-600" />
          </div>
          
          <div className="space-y-2">
            <h1 className="text-2xl font-bold text-gray-900">
              System Under Maintenance
            </h1>
            <p className="text-gray-600">
              {maintenanceStatus?.message || 'We are currently performing scheduled maintenance. Please check back later.'}
            </p>
          </div>

          <div className="space-y-3">
            {userRole === 'admin' && (
              <Button 
                onClick={handleAdminPanel}
                className="w-full"
                variant="default"
              >
                <Settings className="h-4 w-4 mr-2" />
                Admin Panel
              </Button>
            )}
            
            <Button 
              onClick={handleSignOut}
              variant="outline"
              className="w-full"
            >
              <LogOut className="h-4 w-4 mr-2" />
              Sign Out
            </Button>
          </div>

          <div className="text-xs text-gray-500 pt-4 border-t">
            If you believe this is an error, please contact your system administrator.
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default MaintenancePage;